import type { FC } from 'react';
import { useCallback } from 'react';
import type { GestureResponderEvent } from 'react-native';

import { useLikeComment } from '@/features/api/hooks/grapevine-comment-events/useLikeComment';
import { useUnlikeComment } from '@/features/api/hooks/grapevine-comment-events/useUnlikeComment';
import { LikeButton } from '@/features/posts/components/LikeButton';
import { isEmptyOrNull } from '@/shared/utils/string';

type LikeButtonProps = {
  commentId?: string;
  liked?: boolean | null;
  likeCount?: number;
};

export const CommentLikeButton: FC<LikeButtonProps> = ({
  commentId = '',
  liked = false,
  likeCount = 0
}) => {
  const likeComment = useLikeComment();
  const unlikeComment = useUnlikeComment();

  const handleLikeToggle = useCallback(
    (e: GestureResponderEvent) => {
      e.preventDefault();
      if (isEmptyOrNull(commentId)) return;

      if (liked) {
        unlikeComment.mutate(commentId);
      } else {
        likeComment.mutate(commentId);
      }
    },
    [commentId, liked, unlikeComment, likeComment]
  );

  return (
    <LikeButton
      handleLikeToggle={handleLikeToggle}
      disabled={likeComment.isPending || unlikeComment.isPending}
      likeCount={likeCount}
      liked={liked}
    />
  );
};
